import { processListingParams } from '@/api/helpers';
import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import {
  Benchmark,
  ListBenchmarksRequest,
  ListBenchmarksResponse,
  SaveBenchmarkRequest,
  UpdateBenchmarkRequest,
} from './types';

export const benchmarksService = (client: AxiosInstance) => {
  const BENCHMARKS_BASE_URL = '/gophish/campaign-benchmarks';

  const getBenchmarks = async (
    params: ListBenchmarksRequest,
  ): Promise<ListBenchmarksResponse> => {
    try {
      const result = await client.get<
        ListBenchmarksResponse,
        AxiosResponse<ListBenchmarksResponse>
      >(BENCHMARKS_BASE_URL, {
        withCredentials: true,
        params: processListingParams(params),
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const updateBenchmark = async (
    request: UpdateBenchmarkRequest,
  ): Promise<Benchmark> => {
    try {
      const result = await client.patch(
        `${BENCHMARKS_BASE_URL}/${request.benchmarkId}`,
        request.updates,
        {
          withCredentials: true,
        },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const saveBenchmark = async (
    request: SaveBenchmarkRequest,
  ): Promise<Benchmark> => {
    try {
      const result = await client.post(BENCHMARKS_BASE_URL, request, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getBenchmarks,
    updateBenchmark,
    saveBenchmark,
  };
};
